import { isWindowAvailable } from 'utils/browser';

export const SEARCH_HISTORY_NAME = 'wtr_search_history';
const LIMIT = 60;

const getSearchHistoryFeatureFlag = (): boolean => {
  // eslint-disable-next-line no-underscore-dangle
  if (!isWindowAvailable || !window.__WTR_COMMON__) return false;
  // eslint-disable-next-line no-underscore-dangle
  return window.__WTR_COMMON__.featureFlags?.searchHistory ?? false;
};

const decorate = (fn: Function) => (arg: unknown, searchType: string) =>
  fn(arg, `wtr_${searchType ? `${searchType}_` : ''}search_history`);

export const getSavedSearchTerms = decorate((quantity: number, searchName: string) => {
  if (!isWindowAvailable || !getSearchHistoryFeatureFlag()) return [];

  try {
    const name = window.localStorage.getItem(searchName);
    if (!name) throw new Error('Not a valid search history value');
    const parsedValue = JSON.parse(name);
    if (!parsedValue || !Array.isArray(parsedValue)) {
      throw new Error('Not a valid search history value');
    }
    return parsedValue.slice(0, quantity).map(({ t }) => t);
  } catch {
    window.localStorage.removeItem(searchName);
  }

  return [];
});

export const saveSearchTerm = decorate((term: string, searchName: string) => {
  if (!isWindowAvailable || !getSearchHistoryFeatureFlag() || !term.length) return;

  let searchHistory = [];
  try {
    const name = window.localStorage.getItem(searchName);
    if (!name) throw new Error('Not a valid search history value');
    const parsedValue = JSON.parse(name);
    if (!parsedValue || !Array.isArray(parsedValue)) {
      throw new Error('Not a valid search history value');
    }

    searchHistory = [...parsedValue];

    searchHistory = searchHistory.filter(({ t }) => `${t}`.toLowerCase() !== term.toLowerCase());

    if (searchHistory.length >= LIMIT) {
      searchHistory = searchHistory.slice(0, LIMIT - 1);
    }
  } catch {
    window.localStorage.removeItem(searchName);
  }

  searchHistory.unshift({ t: term });

  window.localStorage.setItem(searchName, JSON.stringify(searchHistory));
});

export const removeSavedSearchTerm = decorate((term: string, searchName: string) => {
  if (!isWindowAvailable || !getSearchHistoryFeatureFlag()) return;

  try {
    const name = window.localStorage.getItem(searchName);
    if (!name) throw new Error('Not a valid search history value');
    const parsedValue = JSON.parse(name);
    if (!parsedValue || !Array.isArray(parsedValue)) {
      throw new Error('Not a valid search history value');
    }
    window.localStorage.setItem(
      searchName,
      JSON.stringify(parsedValue.filter(({ t }) => t !== term)),
    );
  } catch {
    window.localStorage.removeItem(searchName);
  }
});

export const deleteSearchHistory = (searchType: string) => {
  if (!getSearchHistoryFeatureFlag()) return;

  decorate((_: never, searchName: string) => {
    window.localStorage.removeItem(searchName);
  })(null, searchType);
};
